export const CUSTOMER_ORG_TYPE = "CUSTOMER";
export const PARTNER_ORG_TYPE = "PARTNER";
export const ADMIN_ORG_TYPE = "ADMIN_ORG_TYPE";

export const ADMIN_USER_TYPE = "ADMIN_ORG";
export const CUSTOMER_USER_TYPE = "CUSTOMER_ORG";
export const PARTNER_USER_TYPE = "PARTNER_ORG";
